export default __webpack_public_path__ + "static/media/050_brake.last.9eb806be.avif";